import React from 'react';
import { Drawer, styled } from '@mui/material';
import { drawerClasses } from '@mui/material/Drawer';
import { sidebarGutter } from 'common/constants/general';

// Sidebar premium FLOTANTE (referencia Nolito): panel redondeado con margen respecto
// al viewport, hairline en todos los lados y sombra teñida — ya no es una columna
// pegada al borde. El ancho reservado en el layout = drawerWidth + gutter * 2.
const StyledDesktopDrawer = styled(({ drawerWidth, ...otherProps }) => <Drawer {...otherProps} />)(
  ({ drawerWidth, theme }) => ({
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block'
    },
    [`& .${drawerClasses.paper}`]: {
      backgroundColor: theme.palette.surface.sidebar,
      backgroundImage: 'initial',
      border: `1px solid ${theme.palette.hairline.main}`,
      borderRadius: '16px',
      boxShadow: theme.palette.shadow.card,
      boxSizing: 'border-box',
      height: `calc(100vh - ${sidebarGutter * 2}px)`,
      margin: `${sidebarGutter}px`,
      overflow: 'hidden',
      transition: `width ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut} 0ms`,
      width: drawerWidth
    }
  })
);

export default StyledDesktopDrawer;
